export default __webpack_public_path__ + "static/wp-844f0d7b78bc8bb55f3ecb3e5b6d368c.png";